<template>
    <veui-dialog :open.sync="localOpen"
        overlay-class="stats-report-dialog"
        :title="title"
        draggable>
        <div class="muses-report-chart">
            <div v-if="!chartData.length" class="no-data">暂无相关统计数据</div>
            <v-chart v-else :options="options"/>
        </div>
        <template slot="foot">
            <veui-button @click="localOpen = false">关闭</veui-button>
        </template>
    </veui-dialog>
</template>

<script>
import {Dialog, Button} from 'veui';
import EChart from '@/common/components/EChart';
import {getBaseChartOption, getInteractChartOption} from '@/common/utils/chartOption';

export default {
    name: 'report-chart-dialog',
    components: {
        'v-chart': EChart,
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        chartData: {
            type: Array,
            default() {
                return [];
            }
        },
        reportType: {
            type: String,
            default: 'base'
        },
        title: {
            type: String,
            default: ''
        },
        open: Dialog.props.open
    },
    data() {
        return {
            localOpen: this.open
        };
    },
    watch: {
        open(val) {
            this.localOpen = val;
        },
        localOpen(val) {
            if (this.open !== val) {
                this.$emit('update:open', val);
            }
        }
    },
    computed: {
        options() {
            if (this.reportType === 'base') {
                // 基础指标报告
                return getBaseChartOption(this.chartData);
            }
            // 交互体验报告
            return getInteractChartOption(this.chartData);
        }
    }
};
</script>

<style lang="less">
@import '~veui-theme-one/lib.less';
.muses-report-chart{
    .echarts {
        width: 900px;
        height: 450px;
        margin-top: 15px;
    }

    .no-data {
        font-size: 18px;
        line-height: 200px;
        font-weight: @veui-font-weight-bold;
        text-align: center;
    }
}
</style>
